var _desc, _style, _circle, _ellipse, _g, _circle2, _circle3, _line, _line2, _path, _path2, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-dashboard-title"
  }, "Ei viel\xE4 dashboardeja") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-dashboard-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-dashboard-desc"
  }, "Tyhj\xE4 dashboard-n\xE4kym\xE4, jossa on katkoviivoin merkityt paikat widgeteille ja plus-painike")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-dashboard-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-dashboard-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-dashboard-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-dashboard-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-dashboard-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-dashboard-on-accent { stroke: var(--empty-surface, #ffffff); }\n    .empty-dashboard-pulse  { animation: empty-dashboard-pulse 2.4s ease-out 2 forwards; transform-origin: 192px 150px; }\n    @keyframes empty-dashboard-pulse   { 0% { transform: scale(1); opacity: .45; } 100% { transform: scale(1.9); opacity: 0; } }\n    @media (prefers-reduced-motion: reduce) { .empty-dashboard-pulse { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 86,
    className: "empty-dashboard-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 170,
    rx: 72,
    ry: 6,
    className: "empty-dashboard-accent",
    opacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-dashboard-float"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 168,
    height: 126,
    rx: 10,
    className: "empty-dashboard-surface empty-dashboard-stroke",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 46 a10 10 0 0 1 10 -10 H194 a10 10 0 0 1 10 10 V52 H36 Z",
    className: "empty-dashboard-accent",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 44,
    r: 2.6,
    className: "empty-dashboard-accent",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 44,
    r: 2.6,
    className: "empty-dashboard-accent",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 44,
    r: 2.6,
    className: "empty-dashboard-accent",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 64,
    x2: 62,
    y2: 64,
    className: "empty-dashboard-line",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 76,
    x2: 62,
    y2: 76,
    className: "empty-dashboard-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 88,
    x2: 62,
    y2: 88,
    className: "empty-dashboard-line",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 60,
    width: 62,
    height: 42,
    rx: 6,
    fill: "none",
    className: "empty-dashboard-line",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 94,
    x2: 126,
    y2: 94,
    className: "empty-dashboard-line",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "empty-dashboard-accent empty-dashboard-bar",
    x: 86,
    y: 72,
    width: 7,
    height: 20,
    rx: 2,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "empty-dashboard-accent empty-dashboard-bar empty-dashboard-b",
    x: 99,
    y: 72,
    width: 7,
    height: 20,
    rx: 2,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "empty-dashboard-accent empty-dashboard-bar empty-dashboard-c",
    x: 112,
    y: 72,
    width: 7,
    height: 20,
    rx: 2,
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 60,
    width: 50,
    height: 42,
    rx: 6,
    fill: "none",
    className: "empty-dashboard-line",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 81,
    r: 12,
    fill: "none",
    className: "empty-dashboard-line",
    strokeWidth: 5,
    strokeDasharray: "6 5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 110,
    width: 104,
    height: 40,
    rx: 6,
    fill: "none",
    className: "empty-dashboard-line",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 138 C96 138 100 126 112 128 C124 130 128 140 142 134 C152 130 158 124 166 124",
    fill: "none",
    className: "empty-dashboard-line",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 150,
    r: 15,
    className: "empty-dashboard-accent empty-dashboard-pulse"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 150,
    r: 15,
    className: "empty-dashboard-accent"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 143,
    x2: 192,
    y2: 157,
    className: "empty-dashboard-on-accent",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 150,
    x2: 199,
    y2: 150,
    className: "empty-dashboard-on-accent",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "empty-dashboard-accent empty-dashboard-twinkle",
    d: "M28 30 l2.2 5.8 5.8 2.2 -5.8 2.2 -2.2 5.8 -2.2 -5.8 -5.8 -2.2 5.8 -2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "empty-dashboard-accent empty-dashboard-twinkle empty-dashboard-b",
    d: "M214 24 l1.8 4.5 4.5 1.8 -4.5 1.8 -1.8 4.5 -1.8 -4.5 -4.5 -1.8 4.5 -1.8z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 128,
    r: 3,
    className: "empty-dashboard-accent",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty-dashboard.e84057ae2f083ad66a02711bac3f86fe.svg";
export { ForwardRef as ReactComponent };